import type { Theme } from '@mui/material';

export const styles = {
  listItem: {
    pl: 1,
  },

  contentWrapper: {
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    textWrap: 'noWrap',
  },

  headline: (theme: Theme) => ({
    py: 1,
    pl: 1,
    cursor: 'pointer',
    justifyContent: 'space-between',
    alignItems: 'center',

    '&:hover': {
      backgroundColor: theme.colors.neutral[100],
    },
  }),

  nestedContent: {},
};
